import { render, staticRenderFns } from "./CampaignHighlight.vue?vue&type=template&id=33d05a10"
import script from "./CampaignHighlight.vue?vue&type=script&lang=js"
export * from "./CampaignHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports